module.exports = __webpack_public_path__ + "img/littl_girls2.eb7dd72b.jpg";